// @flow

export default {
	ORDER: 'order',
	BILL: 'bill',
	BILL_BUFFER: 'bill_buffer',
}
